import { render, staticRenderFns } from "./CompletedCampaignBox.vue?vue&type=template&id=23fbd20c&scoped=true&"
import script from "./CompletedCampaignBox.vue?vue&type=script&lang=js&"
export * from "./CompletedCampaignBox.vue?vue&type=script&lang=js&"
import style0 from "./CompletedCampaignBox.vue?vue&type=style&index=0&id=23fbd20c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fbd20c",
  null
  
)

export default component.exports